export const DELAY_TRANSITION_MS_DEFAULT = 500
export const DELAY_TRANSITION_MS_QUESTIONS = 300
